import { render } from "./ReportAccident.vue?vue&type=template&id=0e49794a"
import script from "./ReportAccident.vue?vue&type=script&lang=js"
export * from "./ReportAccident.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__